<template>
    <div id="app">
        <router-view />
    </div>
</template>

<script>
    export default {
        name: 'App',
        data() {
            return {};
        },
        created() {
            this.isMobile();
        },
        methods: {
            isMobile() {
                if (window.navigator.userAgent.match( /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)) {
                    window.location.href="https://bhgc.art/h5/";
                    // return true; // 移动端
                } else {
                    // window.location.href="https://bhgc.eacase.net/baihuipc/#/";
                    // return false; // PC端
                }
            }
        }
    };
</script>

<style lang="scss">
    @import url("//at.alicdn.com/t/font_3224977_mkrmppjayqa.css"); //、iconfont 线上地址
    @import "assets/css/main.scss";

    #app {
        font-family: 'Avenir', Helvetica, Arial, sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
    }
    
     .jltitle {
        width: 304px;
        padding: 25px 30px 26px;
        background: url(../static/img/titlehuan.png) 0px 0px no-repeat;
        background-size: 100%;
        margin: 0px auto 50px;
        text-align: center;
        font-size: 26px;
        color: #fff;
        font-weight: bold;
        font-family: '仿宋';
        span{
            display: inline-block;
            height:48px;
            line-height:48px;
        }
    }
</style>



// WEBPACK FOOTER //
// src/App.vue